<div [formGroup]="form!">
  <div
    [formGroupName]="formControl"
    class="checkbox checkbox--filter"
    [class.checkbox--filterDisabled]="count"
  >
    <input
      type="checkbox"
      class="checkbox__input"
      id="{{ filterOption!.name }}"
      formControlName="{{ filterOption!.name }}"
      (change)="eventEmit(filterOption!.name)"
    />
    <label
      class="checkbox__label"
      [attr.for]="filterOption!.name"
      tabindex="-1"
    >
      {{ filterOption!.label }}
      <span class="filter__amount">({{ filterOption!.count }})</span>
    </label>
  </div>
</div>
